import { CognitoUserPool, CookieStorage } from "amazon-cognito-identity-js"
import IdleTimer from "../../../../../Applications/Utilities/idleTimer"
import { makeUnauthGetRequest } from "../../../utils/lambda/unauthRequests"
import { setProtocols } from "./sso"
import {
  STORE_USER_SESSION,
  SIGN_USER_OUT,
  STORE_USER_POOL,
  STORE_MODULES,
  USER_EMAIL,
  TOP_DOMAIN,
  RENDER_APPLICATION,
  STORE_SESSION_TIMER,
  STORE_SESSION_TIMER_INFO,
  DELETE_SESSION_TIMER,
  SET_USER_DETAILS,
} from "../constants"

export const storeUserPool = (userPool, loggedOut) => ({
  loggedOut,
  userPool,
  type: STORE_USER_POOL,
})

export const signUserOut = ({ userPool }) => {
  const user = userPool?.getCurrentUser()
  if (user) user.signOut()
  return {
    type: SIGN_USER_OUT,
  }
}

export const storeUserSession = ({ userPool, session, cookies }) => {
  const user = userPool.getCurrentUser()

  if (!user) return signUserOut({ userPool })

  user.signOut.bind(user)

  const idTokenPayload = session.getIdToken().payload
  const refreshToken = session.getRefreshToken()

  const { email } = idTokenPayload

  cookies?.set(USER_EMAIL, email, { path: "/", domain: TOP_DOMAIN })

  return {
    signOut: user.signOut,
    session,
    userPool,
    refreshToken,
    idTokenPayload,
    type: STORE_USER_SESSION,
  }
}

export const refreshSession = ({
  userPool,
  refreshToken,
  cookies,
  history,
  pathAppend,
  dispatch,
}) =>
  userPool.getCurrentUser().refreshSession(refreshToken, (err, session) => {
    if (err) {
      console.error(err)
      history.push(`/logout${pathAppend}`)
    } else dispatch(storeUserSession({ userPool, session, cookies }))
  })

export const refreshUser = ({ dispatch, getState }) => {
  const {
    sessionReducer: { userPool, refreshToken, session },
  } = getState()

  const desiredRedirect = window.location.href.replace(
    window.location.origin,
    ""
  )

  const pathAppend =
    desiredRedirect === "/"
      ? ""
      : `?refer=${desiredRedirect.split("refer=").pop()}`

  if (session) {
    if (session.isValid()) {
      if (userPool && refreshToken)
        refreshSession({ refreshToken, userPool, dispatch })
    } else window.location.replace(`/logout${pathAppend}`)
  }
}

export const checkSession = (
  { info, loadAuthenticatedUser, renderApplication, history },
  dispatch
) => {
  const UserPoolId = info.cognito_user_pool_id
  const ClientId = info.cognito_app_client_id
  const domain = window.location.host
  const userPool = new CognitoUserPool({
    UserPoolId,
    ClientId,
    Storage: new CookieStorage({ domain }),
  })
  const cognitoUser = userPool.getCurrentUser() || null

  if (cognitoUser !== null) loadAuthenticatedUser({ userPool, cognitoUser })

  return makeUnauthGetRequest({
    url: "/iam_v1/sso/details",
    onSuccess: ({ protocols }) => {
      dispatch(setProtocols(protocols))
      if (protocols.length > 0) {
        if (cognitoUser === null) {
          if (window.location.pathname !== "/sso/login") {
            history.push(
              `/sso/login?refer=${window.location.pathname}${
                window.location.search.length
                  ? `?${window.location.search.slice(1)}`
                  : ""
              }`
            )
          }
        }
      } else {
        const loggedOut = cognitoUser === null
        dispatch(storeUserPool(userPool, loggedOut))
      }
      renderApplication()
    },
    onFailure: () => {
      history.push("/error/500")
      console.error("no sso details")
    },
  })
}

export const storeModules = (data) => ({
  features: data.features,
  type: STORE_MODULES,
})

export const renderApplication = (render = true) => ({
  render,
  type: RENDER_APPLICATION,
})

export const storeSessionTimerInfo = (sessionExpiryTime) => ({
  sessionExpiryTime,
  type: STORE_SESSION_TIMER_INFO,
})

export const storeSessionTimer = (store) => ({
  sessionTimer: new IdleTimer({ store, refreshUser, storeSessionTimerInfo }),
  type: STORE_SESSION_TIMER,
})

export const deleteSessionTimer = () => ({ type: DELETE_SESSION_TIMER })

export const setUserDetails = (userDetails) => ({
  userDetails,
  type: SET_USER_DETAILS,
})
